import React from "react";
import { t } from "ttag";

import { IProduct } from "../models/catalogue.interfaces";

interface IProps {
    variant: IProduct | null;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to simple render with no state or lifecycle methods.
export class ProductUnavailable extends React.PureComponent<IProps, IState> {
    render() {
        let reasonMessage: string = t`This product does not come in this configuration`;
        if (this.props.variant) {
            if (this.props.variant.availability.is_available_to_buy) {
                return null;
            }
            reasonMessage = this.props.variant.availability.message;
        }
        return <div className="configurator__unavailable">{reasonMessage}</div>;
    }
}
